/*
 * @Author: Roman
 * @Date: 2022-11-08 13:54:28
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2022-11-08 17:22:03
 * @FilePath: \qpmn-site\src\app\modules\product-catalog\model\dto\NewProductsSort.ts
 * @Description: 
 */
import { PageSort } from "@modules/main/model/dto/sort/PageSort";

export class NewProductsSort extends PageSort {

    public property: string = "dateAvailable";

    public direction: string = "DESC";
}